/**
 * Mutación para guardar los datos de un evento y mostrar un preview del mismo (Aún sin terminar)
 * @param {State} state Estado de Vue
 * @param {Object} event Objeto de evento que será mostrado e el preview
 */
export function setEvent(state, event) {
    state.event = Object.assign(state.event, event);
}

/**
 * Mutación que guardará el evento despupes de ser mostrado en el preview (Aún sin terminar)
 * @param {State} state Estado de Vue
 */
export function saveEvent(state) {
    state.event = Object.assign(state.event, state.base);
}

/**
 * Mutación que guarda los eventos en el estado de Vue, esta mutación es usada para mostrar
 * los eventos en la página de inicio, en la sección de eventos, calendario de eventos de
 * organizador y lista de eventos en el dashboard de organizador.
 * @param {State} state Estado de Vue
 * @param {Array<Object>} events Arreglo de objetos de eventos
 */
export function setEvents(state, events) {
    state.events = events;
}

/**
 * Mutación para guardar la lista de eventos que tiene un organizador y posteriomente ser mostrador en un v-select.
 * @param {State} state Estado de Vue
 * @param {Array<Object>} organizationEventList Lista de eventos de organizador.
 */
export function setOrganizationEventList(state, organizationEventList) {
    state.organizationEventList = organizationEventList;
}

/**
 * Mutación para limpiar la lista de eventos que se muestran en el dashboard del organizador.
 * @param {State} state Estado de Vue
 */
 export function clearOrganizationEvents(state) {
    state.events = [];
    state.organizationEventList = [];
}

/**
 * Mutación que va almacenando bloques de 400 ordenes que contienen asistentes
 * (CADA TRANSACCIÓN PUEDE TENER DIFERENTE CANTIDAD DE ASISTENTES,
 * PUEDE SER UN SOLO ASISTENTE HASTA 5, SEGÚN SEA CONFIGURADO EL EVENTO),
 * @param {State} state Estado de Vue
 * @param {Array<Object>} eventAttendees Lista de asistentes de un evento
 */
export function setEventAttendees(state, eventAttendees) {
    state.eventAttendees.id = eventAttendees._id;
    state.eventAttendees.name = eventAttendees.name;
    state.eventAttendees.attendeeWithPassword = eventAttendees.attendeeWithPassword;
    state.eventAttendees.orders = state.eventAttendees.orders.concat(eventAttendees.orders);
}

/**
 * Mutación que limpia el arreglo de ordenes una vez que el usuario se dirige a otra pestaña.
 * @param {State} state Estado de Vue
 */
export function clearEventAttendeesInformation(state) {
    state.eventAttendees.id = "";
    state.eventAttendees.name = "";
    state.eventAttendees.attendeeWithPassword = false;
    state.eventAttendees.orders.length = 0;
}

/**
 * Mutación para obtener la cantidad de ventas y asistentes por evento.
 * @param {State} state Estado de Vue.
 * @param {Object} eventAttendeesTransactions Objeto de evento con id, nombre y transacciones de ese evento.
 */
export function setEventAttendeesTransactions(state, eventAttendeesTransactions) {
    state.eventAttendeesTransactions.id = eventAttendeesTransactions._id;
    state.eventAttendeesTransactions.name = eventAttendeesTransactions.name;
    state.eventAttendeesTransactions.orders = eventAttendeesTransactions.orders;
}

/**
 * 
 * @param {State} state Estado de Vue
 * @param {*} event 
 */
export function setCurrentEvent(state, event) {
    state.currentEvent = event;
}

/**
 * Mutación que guarda todos los filtros de búsqueda que se le esta aplicando a un evento
 * @param {State} state Estado de Vue.
 * @param {Object} data Objeto del filtro de búsqueda que se le esta aplicando a la lista de eventos.
 */
export function setFilter(state, data) {
    state.filter[data["filter"]] = data.value;
}

/**
 * Mutación que sirve para activar el modo dark en el detalle del evento (Solo funciona el nos eventos que tienen activada esta funcionalidad).
 * @param {State} state Estado de Vue
 */
export function exitDarkMode(state, data) {
    state.currentEvent.darkMode = false;
    state.event.darkMode = false;
}

/**
 * Mutación que sirve para avisar si todavía hay boletos disponibles en un evento
 * @param {State} state Estado de Vue.
 * @param {Boolean} value Valor de tickets activos: true = boletos dispoibles, false = boletos no disponibles.
 */
export function setTicketsOutOfStock(state, value) {
    state.ticketsOutOfStock = value;
}